import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=anon
  const [error, setError] = useState("");

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    setError("");
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const register = async (email, password, name, ref = null, consent = {}) => {
    setError("");
    const url = ref ? `/auth/register?ref=${encodeURIComponent(ref)}` : "/auth/register";
    const payload = {
      email, password, name,
      accepted_terms: !!consent.accepted_terms,
      age_confirmed: !!consent.age_confirmed,
      marketing_opt_in: !!consent.marketing_opt_in,
    };
    const { data } = await api.post(url, payload);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      // Logout is idempotent on the server. Network/401 here is fine — we
      // still clear local state below so the user is logged out either way.
      console.warn("logout request failed (clearing local state anyway):", e?.message || e);
    }
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, error, setError, login, register, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
